const initProductPage = () => {
  document.addEventListener('variant:changed', (e) => {
    const hiddenAddToCartButton = document.querySelector('.product-variant-id');
    // add variant id to the query string
    const url = new URL(window.location.href);
    url.searchParams.set('variant', e.detail.variantId);
    if (hiddenAddToCartButton) {
      hiddenAddToCartButton.value = e.detail.variantId;
    }
    window.history.replaceState({}, '', url);
  });
};

document.addEventListener('DOMContentLoaded', initProductPage);
